export const contentProportionalValue = {
	quantity: "Cantidad",
	unityMeasurement: "Unidad de medida",
	requiredField: "Campo obligatorio",
	infoMessageMyTapp:
		"No es posible desactivar esta función mientras 'Sincronizar con My Tapp' esté activa.",
	placeholder: {
		quantity: "Ingrese una cantidad",
		unitMeasurement: "Seleccione",
	},
	optionsUnitMeasurement: {
		ml: "Mililitros",
		gm: "Gramos",
		un: "Unidad",
	},
};
